export const standardsUrl =
  'https://content-standards-exchange.acceleratelearning.com/standards.json';
